import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getProductsURL } from '../utils/api';

const useGetProducts = ({ 
        page = 1,
        limit = 3000,
        keyword,
        supplierKeyword, 
        withStocks,
        orderBy,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingProducts, setGettingProducts ] = useState(false);
    const [ products, setProducts ] = useState([]);
    const [ totalProducts, setTotalProducts ] = useState(0);
    const [ gettingProductsReqSuccess, setGettingProductsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingProducts) {
            axios.get(getProductsURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword, 
                    supplierKeyword, 
                    withStocks: (withStocks == true || withStocks == false) ? withStocks : undefined, 
                    orderBy,
                }
            }).then(result => {
                setGettingProducts(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalProducts(result.data.total);
                    }
                    setGettingProductsReqSuccess(true);
                    setProducts(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingProductsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingProductsReqSuccess(false);
                setGettingProducts(false);
            });
        }
    }, [gettingProducts]);

    return { products, totalProducts, gettingProducts, setGettingProducts, gettingProductsReqSuccess };
}

export default useGetProducts;